var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c(
        "v-tabs",
        {
          staticClass: "mb-0",
          attrs: {
            flat: "",
            "background-color": "transparent"
          }
        },
        [
          _c("v-tabs-slider", {
            attrs: {
              color: "green"
            }
          }),
          _c(
            "v-tab",
            {
              attrs: {
                to: {
                  name: "profile_info"
                },
                exact: ""
              }
            },
            [_vm._v(" Profile Info ")]
          ),
          _c(
            "v-tab",
            {
              attrs: {
                to: {
                  name: "billing"
                }
              }
            },
            [_vm._v(" Billing ")]
          ),
          _c(
            "v-tab",
            {
              attrs: {
                to: {
                  name: "profile_security"
                }
              }
            },
            [_vm._v(" Security ")]
          ),
          _c(
            "v-tab",
            {
              attrs: {
                to: {
                  name: "profile_privacy"
                }
              }
            },
            [_vm._v(" Privacy ")]
          ),
          _c(
            "v-tab",
            {
              attrs: {
                to: {
                  name: "profile_access"
                }
              }
            },
            [_vm._v(" Account Access ")]
          ),
          _c(
            "v-tab",
            {
              attrs: {
                to: {
                  name: "profile_ggseal"
                }
              }
            },
            [_vm._v(" GreenGeeks Seal ")]
          )
        ],
        1
      ),
      _c("hr", {
        staticClass: "mt-0 mb-md-4"
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }